export var TypeActionOutskirtsInfo;
(function (TypeActionOutskirtsInfo) {
    TypeActionOutskirtsInfo["Received"] = "OutskirtsInfo > Received";
    TypeActionOutskirtsInfo["Update"] = "OutskirtsInfo > Update";
    TypeActionOutskirtsInfo["UpdateImprovementInfo"] = "OutskirtsInfo > UpdateImprovementInfo";
    TypeActionOutskirtsInfo["UpdateStageInfo"] = "OutskirtsInfo > UpdateStageInfo";
    TypeActionOutskirtsInfo["Upgrade"] = "OutskirtsInfo > Upgrade";
    TypeActionOutskirtsInfo["UpgradeRequest"] = "OutskirtsInfo > UpgradeRequest";
    TypeActionOutskirtsInfo["SelectOutskirtBuilding"] = "OutskirtsInfo > SelectOutskirtBuilding";
    TypeActionOutskirtsInfo["DeselectOutskirtBuilding"] = "OutskirtsInfo > DeselectOutskirtBuilding";
    TypeActionOutskirtsInfo["LoadNextLevelAssets"] = "OutskirtsInfo > LoadNextLevelAssets";
})(TypeActionOutskirtsInfo || (TypeActionOutskirtsInfo = {}));
export var actionOutskirtsInfoReceived = function (outskirtsInfo) { return ({
    outskirtsInfo: outskirtsInfo,
    type: TypeActionOutskirtsInfo.Received,
}); };
export var actionOutskirtsInfoUpdate = function (info) { return ({
    info: info,
    type: TypeActionOutskirtsInfo.Update,
}); };
export var actionOutskirtsInfoUpdateImprovementInfo = function (id, improvement) { return ({
    id: id,
    improvement: improvement,
    type: TypeActionOutskirtsInfo.UpdateImprovementInfo,
}); };
export var actionOutskirtsInfoUpdateStageInfo = function (info) { return ({
    info: info,
    type: TypeActionOutskirtsInfo.UpdateStageInfo,
}); };
export var actionOutskirtBuildingUpgrade = function (building) { return ({
    building: building,
    type: TypeActionOutskirtsInfo.Upgrade,
}); };
export var actionOutskirtBuildingUpgradeRequest = function (building) { return ({
    building: building,
    type: TypeActionOutskirtsInfo.UpgradeRequest,
}); };
export var actionOutskirtBuildingSelect = function (buildingId) { return ({
    buildingId: buildingId,
    type: TypeActionOutskirtsInfo.SelectOutskirtBuilding,
}); };
export var actionOutskirtBuildingDeselect = function () { return ({
    type: TypeActionOutskirtsInfo.DeselectOutskirtBuilding,
}); };
export var actionOutskirtBuildingLoadNextLevelAssets = function (building) { return ({
    building: building,
    type: TypeActionOutskirtsInfo.LoadNextLevelAssets,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/actionOutskirtsInfo.ts
// module id = 104
// module chunks = 3